import React, { useState, useEffect } from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomLabel from 'Common/CustomLabel/CustomLabel';
import moment from 'moment-mini';

const CustomDateRangePicker = ({
  wrapperClass,
  label,
  labelClass,
  required,
  name,
  startDateName = 'dateFrom',
  endDateName = 'dateTo',
  startDate,
  endDate,
  onChange,
  onKeyPress,
  maxDate,
  minDate,
  placeholder = 'Select date range',
  className = '',
  ...datePickerProps
}) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDateValue, endDateValue] = dateRange;

  useEffect(() => {
    if (startDate || endDate) {
      setDateRange([
        startDate ? new Date(startDate) : null,
        endDate ? new Date(endDate) : null,
      ]);
    } else if (!startDate && !endDate) {
      setDateRange([null, null]);
    }
  }, [startDate, endDate]);

  const handleDateChange = (update) => {
    setDateRange(update);
    const [start, end] = update;

    const formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : '';
    const formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : '';

    if (onChange) {
      onChange({
        target: {
          name: startDateName,
          value: formattedStartDate,
        },
      });
      onChange({
        target: {
          name: endDateName,
          value: formattedEndDate,
        },
      });
    }
  };

  const handleKeyPress = (e) => {
    if (onKeyPress && e.key === 'Enter') {
      onKeyPress(e);
    }
  };

  return (
    <div className={`flex flex-col gap-2 w-full ${wrapperClass}`}>
      {label && (
        <CustomLabel
          htmlFor={name}
          label={label}
          labelClass={labelClass}
          required={required}
        />
      )}
      <DatePicker
        startDate={startDateValue}
        endDate={endDateValue}
        onChange={handleDateChange}
        selectsRange
        isClearable
        maxDate={maxDate ? new Date(maxDate) : undefined}
        minDate={minDate ? new Date(minDate) : undefined}
        placeholderText={placeholder}
        onKeyDown={handleKeyPress}
        className={`customInputClass h-9 w-full ${className}`}
        dateFormat="MM/dd/yyyy"
        wrapperClassName="w-full"
        {...datePickerProps}
      />
    
    </div>
  );
};

export default withFeatureSafe(CustomDateRangePicker);